<template>
  <div class="quickWithdrawalBenefit">
    <span class="applydrawable">{{$t('upgrade_page_views_withdrawalbenfit_quickwithdrabensuc_2410')}}</span>
    <div class="divider"></div>
    <div class="leftSub">
      <div class="steps-1">
        <img src="@/assets/imgs/steps-icon.png" alt=""> <span class="title_1">{{$t('upgrade_page_views_withdrawalbenfit_quickwithdrabensuc_2411')}}</span><span>{{currencyKind}}</span><span>{{amountCount}}</span>
      </div>
      <div class="steps-2">
          <!-- 邊框 -->
      </div>
      <div class="steps-3">
        <img src="@/assets/imgs/steps-icon.png" alt=""> <span>{{$t('upgrade_page_views_withdrawalbenfit_quickwithdrabensuc_2412')}}</span>
      </div>
      <div class="steps-4">
        <!-- <p><span>提領人niceeID：</span><span>{{uuid}}</span></p> -->
        <p><span>{{$t('upgrade_page_views_withdrawalbenfit_quickwithdrabensuc_2413')}}</span><span>{{receiptNo}}</span></p>
        <span class="copyWith" @click="copyWith()">{{$t('upgrade_page_views_withdrawalbenfit_quickwithdrabensuc_2414')}}</span>
      </div>
      <div class="steps-5">
        <img src="@/assets/imgs/steps-icon.png" alt=""><span>{{$t('upgrade_page_views_withdrawalbenfit_quickwithdrabensuc_2415')}}</span>
      </div>
      <div class="linkCustomer" @click="linkCutomer()"><img src="@/assets/imgs/icon-message.png" alt=""><span>{{$t('upgrade_page_layout_header_10')}}</span></div>
    </div>
    <div class="rightTip">
      <h3>TIPS:</h3>
      <!-- <p>1. 添加客服 Line</p> -->
      <p>{{$t('upgrade_page_views_withdrawalbenfit_quickwithdrabensuc_2416')}}</p>
      <p>{{$t('upgrade_page_views_withdrawalbenfit_quickwithdrabensuc_2417')}}</p>
      <p>{{$t('upgrade_page_views_withdrawalbenfit_quickwithdrabensuc_2418')}}</p>
      <p>{{$t('upgrade_page_views_withdrawalbenfit_quickwithdrabensuc_2419')}}</p>
    </div>
  </div>
</template>
<script>
import i18n from '@/locales/index'
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['userInfo'])
  },
  data(){
    const isAccount = (rule,value,callback) =>{
      let d = window.parseFolat(this.dollar)
      //輸入的數字可以是整數，可以是小數，但是不能超過2位小數
      let regEn = /^-?\d{1,4}(?:\.\d{1,2})?$/
      if (!regEn.test(value)) {
        callback(new Error(i18n.t('upgrade_page_views_withdrawalbenfit_quickwithdrabensuc_2420')))
      }else if(value > 3000){
        callback(new Error(i18n.t('upgrade_page_views_withdrawalbenfit_quickwithdrabensuc_2421')))
      }else if(value > d){
        callback(new Error(i18n.t('upgrade_page_views_quick_order_index_1228')))
      }else if(value == 0){
        callback(new Error(i18n.t('upgrade_page_views_withdrawalbenfit_withdrawalbenefit_1604')))
      }
      
      callback()
    }
    return {
      applyForm:{
        amount:'',
      },
      uuid:'',
      receiptNo:'',
      currencyKind:'',
      amountCount:'',
      rules: {
        amount: [
          { required: true, message: i18n.t('upgrade_page_views_withdrawalbenfit_withdrawalbenefit_1595'), trigger: 'blur' },
          {validator: isAccount, trigger: 'blur'}
        ],
      }
    }
  },
  created(){
    this.getData()
  },
  methods:{
    getData(){
      this.amountCount = this.$route.query.amount;
      this.currencyKind = this.$route.query.currencyKind;
      this.uuid = this.$route.query.userUuid;
      this.receiptNo = this.$route.query.receiptNo;
    },
    linkCutomer(){
      this.$util.openChatWindow(this.userInfo.uuid)
    },
    copyWith() {
      // 添霖改
      // setClipboard(`提領流水號：${this.receiptNo}`).then(() => {
      //   this.$message.success('複製成功')
      // })
    },
  }
}
</script>
<style lang="scss" scoped>
.quickWithdrawalBenefit{
  width: 1200px;
  height: 600px;
  margin: 0 auto;
  padding-top: 30px;
  padding-bottom: 60px;
  margin-top:40px;
  margin-bottom: 100px;
  background: #FFFFFF;
  .leftSub{
    margin-top: 40px;
    margin-left:40px;
    margin-right: 50px;
    float: left;
    .linkCustomer{
      @include flex(left,top,row);
      img{
        width:18px;
        height: 18px;
        vertical-align: middle;
        margin-right: 12px;
      }
      span{
        vertical-align: middle;
      }
      margin-top: 20px;
      margin-left: 30px;
      width: 124px;
      height: 46px;
      border-radius: 4px;
      font-size: 16px;
      color: #FA006E;
      border: 1px solid #FA006E;
      display: block;
      text-align: center;
      line-height: 40px;
      &:hover{
        cursor: pointer;
      }
    }
    .steps-5{
      img{
        width:16px;
        height: 16px;
        margin-right: 17px;
        vertical-align: middle;
      }
      span{
        font-weight: 500;
        font-size: 16px;
        line-height: 22px;
        color: #333333;
        vertical-align: middle;
      }
    }
    .steps-4{
      height: 119px;
      border-left: 1px dashed #BBBBBB;
      margin-left: 7.5px;
      padding-top: 10px;
      padding-left: 30px;
      p{
        height: 26px;
        font-size: 16px;
        color: #333333;
        margin-bottom: 4px;
      }
      .copyWith{
        height: 26px;
        font-size: 16px;
        color: #3E67C5;
        margin-top:10px; 
        &:hover{
          cursor: pointer;
        }
      }
    }
    .steps-3{
      img{
        width:16px;
        height: 16px;
        margin-right: 17px;
        vertical-align: middle;
      }
      span{
        font-weight: 500;
        font-size: 16px;
        line-height: 22px;
        color: #333333;
        vertical-align: middle;
      }
    }
    .steps-2{
      width: 1px;
      height: 41px;
      border: 1px dashed #BBBBBB;
      transform: matrix(-1, 0, 0, 1, 0, 0);
      margin-left: 7.5px;
    }
    .steps-1{
      img{
        width:16px;
        height: 16px;
        margin-right: 17px;
        vertical-align: middle;
      }
      .title_1{
        font-weight: 500;
        font-size: 16px;
        line-height: 22px;
        color: #333333;
        margin-right: 10px;
        vertical-align: middle;
      }
      span{
        font-weight: 500;
        font-size: 22px;
        line-height: 31px;
        color: #333333;
        vertical-align: middle;
      }
    }
  }
  .rightTip{
    float: left;
    width: 462px;
    height:255px;
    background: #F6F6F6;
    border-radius: 4px;
    margin-top: 40px;
    padding: 20px 0 33px 20px;
    h3{
      font-weight: 600;
      font-size: 16px;
      line-height: 22px;
      color: #666666;
      margin-bottom: 20px;
    }
    p{
      font-size: 14px;
      line-height: 20px;
      color: #666666;
      margin-bottom: 15px;
    }
  }
  .divider{
    width: 1200px;
    height: 2px;
    background: #F4F4F4;
    margin-top: 20PX;
  }
  .applydrawable{
    margin-left: 40px;
    font-size: 22px;
    line-height: 31px;
    color: #333333;
  }
}
</style>